import React from 'react'
import Timeline from '../components/Timeline'
import "../style/Experience.css"

  
  
function Experience() {
  return (
    <>
    <div className='container-fluid background h-100 mt-5 experience' >
    <Timeline />
    </div>
   
    </>
  )
}

export default Experience